enum MaterialTypes {
  StainlessSteel = 'Stainless Steel',
  PowderCoated = 'Powder Coated',
  SolidPlastic = 'Solid Plastic',
  Phenolic = 'Phenolic',
}

export default MaterialTypes;
